// Import JS
import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
Swiper.use([Autoplay, Navigation]);
import { Fancybox } from "@fancyapps/ui";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import "./components/accordions";
import { ExpandedBtn } from "./components/expanded-btn.js";
import { Modal } from "./components/modal.js";
import { TeamFilter } from "./components/team-filter.js";
import { debounce, updateHeaderOffsetVars, updateLayoutVars, getContainerPosLeft } from "./tools/utils";

const mediaQueryTablet = window.matchMedia("(max-width: 1200px)");

// Get offset x of header__inner and set as css var on the body
const headerInnerOffsetX = document.querySelector(".header__inner").getBoundingClientRect().left;
document.body.style.setProperty("--header-inner-offset-x", `${headerInnerOffsetX}px`);
window.addEventListener("resize", () => {
	const headerInnerOffsetX = document.querySelector(".header__inner").getBoundingClientRect().left;
	document.body.style.setProperty("--header-inner-offset-x", `${headerInnerOffsetX}px`);
});

// Global functions
// get left/top position of a element
const offset = (el) => {
	const rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.scrollX,
		top: rect.top + window.scrollY,
	};
};

// Add class when elem reach the top
let animateHTML = function ($elements, $offset = "0", $class = "is-visible") {
	let elems, windowHeight;

	let init = function () {
		elems = $elements;
		windowHeight = window.innerHeight;
		_addEventHandlers();
	};

	let _addEventHandlers = function () {
		window.addEventListener("scroll", _checkPosition);
		window.addEventListener("resize", init);
	};

	let _checkPosition = function () {
		for (let i = 0; i < elems.length; i++) {
			let posFromTop = elems[i].getBoundingClientRect().top;
			if (posFromTop + $offset - windowHeight <= 0) {
				elems[i].classList.add($class);
			}
		}
	};

	return {
		init: init,
	};
};

global.getBrowser = () => {
	if (navigator.userAgent.indexOf("OPR") != -1) {
		return "opera";
	} else if (navigator.userAgent.indexOf("Edg") > -1) {
		return "edge";
	} else if (navigator.userAgent.indexOf("Chrome") != -1) {
		return "chrome";
	} else if (navigator.userAgent.indexOf("Safari") != -1) {
		return "safari";
	} else if (navigator.userAgent.indexOf("Firefox") != -1) {
		return "firefox";
	} else if (navigator.userAgent.indexOf("MSIE") != -1 || !!document.documentMode == true || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		//IF IE > 10
		return "ie";
	} else {
		return "... something else?";
	}
};

$(document).ready(function () {
	if ($("#single-property").length >= 1 || $(".archive-results__map").length >= 1 || $(".banner-form").length >= 1) {
		$("#sticky-estimate-mobile").css("display", "none");
	} else {
		$("#sticky-estimate-mobile").css("display", "flex");
	}

	let triggerVideoModal = document.querySelectorAll(".js-open-video");
	let closeVideoModal = document.querySelector(".js-close-modal");
	let videoModal = document.querySelector(".js-modal-video");
	let videoModalInner = document.querySelector(".js-modal-video .modal__content");

	if (triggerVideoModal) {
		// Create the iframe
		let videoFrame = document.createElement("iframe");
		videoFrame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
		videoFrame.allowFullscreen = "allowfullscreen";
		videoFrame.frameBorder = "0";

		// Open the modal and inject iframe
		$(triggerVideoModal).click((e) => {
			e.preventDefault();
			$(videoModal).addClass("is-open");
			let videoID = $(triggerVideoModal).attr("data-video-id");
			let videoSrc = "https://www.youtube-nocookie.com/embed/" + videoID;

			videoFrame.src = videoSrc;
			$(videoModalInner).append(videoFrame);
		});

		// Close the modal and remove the iframe src
		$(closeVideoModal).click((e) => {
			e.preventDefault();
			$(videoModal).removeClass("is-open");
			videoFrame.src = "";
		});
	}
});

document.addEventListener("DOMContentLoaded", function () {
	Modal.init();

	// Lignes de section (.section-line) : dépliage au scroll (toutes les pages)
	gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
		document.querySelectorAll(".section-line").forEach((line) => {
			const triggerEl = line.parentElement;
			if (!triggerEl) {
				return;
			}
			gsap.to(line, {
				scaleX: 1,
				ease: "none",
				scrollTrigger: {
					trigger: triggerEl,
					start: "top 80%",
					end: "top 38%",
					scrub: 2,
				},
			});
		});
	});

	// Cartes services : slider Swiper uniquement ≤879px (même seuil que $bp-small / app.js)
	const servicesSliderRoot = document.querySelector(".cards-services-slider");
	if (servicesSliderRoot) {
		const servicesBreakpoint = window.matchMedia("(max-width: 879px)");
		let servicesSwiper;

		const enableServicesSwiper = () => {
			servicesSwiper = new Swiper(servicesSliderRoot, {
				slidesPerView: 2.15,
				spaceBetween: 12,
				speed: 500,
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,
			});
		};

		const servicesBreakpointChecker = () => {
			if (servicesBreakpoint.matches) {
				if (servicesSwiper === undefined) {
					enableServicesSwiper();
				}
			} else if (servicesSwiper !== undefined) {
				servicesSwiper.destroy(true, true);
				servicesSwiper = undefined;
			}
		};

		servicesBreakpoint.addEventListener("change", servicesBreakpointChecker);
		servicesBreakpointChecker();
	}

	// update layout vars
	updateLayoutVars();
	getContainerPosLeft();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	if ($(".procab-slider")) {
		Fancybox.bind('[data-fancybox^="procab-slider"]', {});
	}

	let body = document.body;
	let wrapper = offset(document.querySelector(".wrapper"));

	// HEADER
	let header = document.querySelector(".header");
	let searchFormInput = document.querySelector(".search-box__form input");
	let triggerSearchForm = document.querySelector(".js-trigger-search");

	updateHeaderOffsetVars();
	window.addEventListener("resize", debounce(updateHeaderOffsetVars, 150));

	// Fond du header au scroll (sync initiale + bfcache)
	const syncHeaderFilled = () => {
		if (!header) {
			return;
		}
		header.classList.toggle("is-filled", window.scrollY >= 30);
		document.body.classList.toggle("header-is-sticky", window.scrollY >= 30);
	};

	window.addEventListener("scroll", syncHeaderFilled, { passive: true });
	window.addEventListener("resize", debounce(syncHeaderFilled, 150));
	window.addEventListener("pageshow", (e) => {
		if (e.persisted) {
			syncHeaderFilled();
		}
	});

	// Classe sur le header quand un méga-menu est visible (desktop : survol, mobile : accordéon)
	const mqDesktopNav = window.matchMedia("(min-width: 1201px)");
	const syncHeaderMegamenuFromDom = () => {
		if (!header) {
			return;
		}
		const subnavOpen = !!document.querySelector(".nav--header .navbar__item.has-children.is-open");
		header.classList.toggle("is-megamenu-open", subnavOpen);
	};

	const syncSubmenuListOffset = (item) => {
		if (!mqDesktopNav.matches) {
			return;
		}

		const submenu = item.querySelector(".navbar__submenu");
		if (!submenu) {
			return;
		}

		const link = item.querySelector(":scope > a");
		const wrapper = submenu.querySelector(".wrapper-xl");
		if (!link || !wrapper) {
			return;
		}

		const offset = link.getBoundingClientRect().left - wrapper.getBoundingClientRect().left;
		submenu.style.setProperty("--submenu-list-offset", `${Math.max(0, offset)}px`);
	};

	const syncAllSubmenuListOffsets = () => {
		document.querySelectorAll(".nav--header .navbar__item.has-children:not(.has-megamenu)").forEach(syncSubmenuListOffset);
	};

	const bindDesktopSubnavHeaderState = (item) => {
		item.addEventListener("mouseenter", () => {
			if (mqDesktopNav.matches) {
				header.classList.add("is-megamenu-open");
			}
		});
		item.addEventListener("mouseleave", () => {
			if (!mqDesktopNav.matches) {
				return;
			}
			requestAnimationFrame(() => {
				if (!item.contains(document.activeElement)) {
					header.classList.remove("is-megamenu-open");
				}
			});
		});
		item.addEventListener("focusin", () => {
			if (mqDesktopNav.matches) {
				header.classList.add("is-megamenu-open");
			}
		});
		item.addEventListener("focusout", (e) => {
			if (!mqDesktopNav.matches) {
				return;
			}
			if (item.contains(e.relatedTarget)) {
				return;
			}
			header.classList.remove("is-megamenu-open");
		});
	};

	const resetMobileSubnav = () => {
		document.querySelectorAll(".nav--header .navbar__item.has-children").forEach((item) => {
			item.classList.remove("is-open");
			const link = item.querySelector(":scope > a");
			if (link) {
				link.setAttribute("aria-expanded", "false");
			}
			const container = item.querySelector(".navbar__submenu, .megamenu");
			if (container) {
				container.classList.remove("is-active");
				container.style.height = "";
			}
		});
		syncHeaderMegamenuFromDom();
	};

	const closeSiblingMobileSubnav = (currentItem) => {
		const navbar = currentItem.closest(".navbar");
		if (!navbar) {
			return;
		}
		navbar.querySelectorAll(".navbar__item.has-children.is-open").forEach((openItem) => {
			if (openItem === currentItem) {
				return;
			}
			openItem.classList.remove("is-open");
			const otherLink = openItem.querySelector(":scope > a");
			if (otherLink) {
				otherLink.setAttribute("aria-expanded", "false");
			}
			const c = openItem.querySelector(".navbar__submenu, .megamenu");
			if (c) {
				c.classList.remove("is-active");
				c.style.height = "";
			}
		});
	};

	if (header) {
		header.querySelectorAll(".navbar__item.has-children").forEach((item) => {
			bindDesktopSubnavHeaderState(item);

			if (item.classList.contains("has-megamenu")) {
				return;
			}

			item.addEventListener("mouseenter", () => syncSubmenuListOffset(item));
			item.addEventListener("focusin", () => syncSubmenuListOffset(item));
		});

		syncAllSubmenuListOffsets();
		window.addEventListener("resize", debounce(syncAllSubmenuListOffsets, 150));
	}

	mediaQueryTablet.addEventListener("change", (e) => {
		if (!e.matches) {
			resetMobileSubnav();
		}
	});

	// Open SearchBar
	if (triggerSearchForm) {
		triggerSearchForm.addEventListener("click", () => {
			header.classList.toggle("search-open");

			setTimeout((e) => {
				document.getElementById("search").focus();
			}, 100);
		});

		document.addEventListener("click", function (event) {
			const isOutside = !event.target.closest(".search-box");
			if (isOutside) {
				header.classList.remove("search-open");
			}
		});
	}

	// Open Mobile Nav
	let burger = document.querySelector(".burger");
	if (burger) {
		burger.addEventListener("click", (e) => {
			e.preventDefault();
			burger.classList.toggle("is-active");
			body.classList.toggle("menu-open");
			if (!body.classList.contains("menu-open")) {
				if (header) {
					header.classList.remove("is-megamenu-open");
				}
				if (mediaQueryTablet.matches) {
					resetMobileSubnav();
				}
			}
		});
	}

	// Button Expanded
	ExpandedBtn.init();
	TeamFilter.init();

	// Agency Panel
	const agencyPanelTrigger = document.querySelector("[data-trigger='agency-panel']");
	if (agencyPanelTrigger) {
		const agencyPanel = document.querySelector("[data-agency-panel]");
		const agencyPanelClose = agencyPanel.querySelector("[data-agency-panel-close]");
		if (agencyPanel) {
			agencyPanelTrigger.addEventListener("click", (e) => {
				e.preventDefault();
				document.body.classList.toggle("agency-panel-open");
				e.currentTarget.classList.toggle("is-active");
			});
			agencyPanelClose.addEventListener("click", (e) => {
				e.preventDefault();
				document.body.classList.remove("agency-panel-open");
				e.currentTarget.classList.remove("is-active");
			});
		}

		// Close agency panel when clicking outside
		document.addEventListener("click", (e) => {
			if (!e.target.closest("[data-agency-panel]") && !e.target.closest("[data-agency-panel-close]") && !e.target.closest("[data-trigger='agency-panel']")) {
				document.body.classList.remove("agency-panel-open");
				agencyPanelTrigger.classList.remove("is-active");
			}
		});

		// Get agency panel width and set var on body
		const agencyPanelWidth = agencyPanel.offsetWidth;
		document.body.style.setProperty("--agency-panel-width", `${agencyPanelWidth}px`);
		// Refresh layout vars on resize
		window.addEventListener(
			"resize",
			debounce(() => {
				const agencyPanelWidth = agencyPanel.offsetWidth;
				document.body.style.setProperty("--agency-panel-width", `${agencyPanelWidth}px`);
				updateLayoutVars();
			}, 150),
		);
	}
	// Sections
	// Add class to animate bkg section
	let animatedSections = document.getElementsByClassName("js-animate");
	if (animatedSections) {
		animateHTML(animatedSections, 150, "is-animated").init();
	}

	// Slider
	let slider = document.querySelector(".slider");

	if (slider) {
		// Push slider to right
		slider.style.setProperty("--offset-slider", `${wrapper.left}px`);

		window.addEventListener("resize", (e) => {
			let divOffset = offset(document.querySelector(".wrapper"));
			slider.style.setProperty("--offset-slider", `${divOffset.left}px`);
		});

		const swiper = new Swiper(slider, {
			slidesPerView: 1,
			spaceBetween: 20,
			speed: 600,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
				disabledClass: "is-disabled",
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
			breakpoints: {
				320: {
					rewind: false,
				},
				700: {
					rewind: true,
					allowTouchMove: false,
				},
			},
		});
	}

	//special slider mobile
	new Swiper(".swiper-mobile", {
		navigation: {
			nextEl: ".swiper-button-next-mobile",
			prevEl: ".swiper-button-prev-mobile",
			disabledClass: "is-disabled",
		},
		pagination: {
			el: ".swiper-pagination-mobile",
			type: "fraction",
		},
	});

	let sliderGrid = document.querySelector(".slider-grid");

	if (sliderGrid) {
		const swiper = new Swiper(sliderGrid, {
			slidesPerView: 1,
			spaceBetween: 20,
			allowTouchMove: true,
			speed: 600,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				type: "fraction",
			},
		});
	}

	function embedUrlWithAutoplay(src) {
		if (!src) {
			return "";
		}
		let normalized = src.trim();
		if (normalized.startsWith("//")) {
			normalized = `https:${normalized}`;
		}
		try {
			const u = new URL(normalized);
			if (!u.searchParams.get("autoplay")) {
				u.searchParams.set("autoplay", "1");
			}
			return u.toString();
		} catch {
			const sep = src.includes("?") ? "&" : "?";
			return `${src}${sep}autoplay=1`;
		}
	}

	function openOembedVideoModal(trigger) {
		const embedBase = trigger.getAttribute("data-oembed-embed");
		if (!embedBase) {
			return false;
		}

		const modal = document.querySelector(".js-modal-video");
		const modalContent = modal?.querySelector(".modal__content");
		if (!modal || !modalContent) {
			return false;
		}

		modalContent.innerHTML = "";
		const iframe = document.createElement("iframe");
		iframe.setAttribute("src", embedUrlWithAutoplay(embedBase));
		iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
		iframe.setAttribute("allowfullscreen", "");
		iframe.setAttribute("title", "Vidéo");
		modalContent.appendChild(iframe);
		modal.classList.add("is-open");
		modal.setAttribute("aria-hidden", "false");
		return true;
	}

	document.querySelectorAll(".js-modal-video").forEach((modal) => {
		const observer = new MutationObserver(() => {
			if (!modal.classList.contains("is-open")) {
				const content = modal.querySelector(".modal__content");
				if (content) {
					content.innerHTML = "";
				}
				modal.setAttribute("aria-hidden", "true");
			}
		});
		observer.observe(modal, { attributes: true, attributeFilter: ["class"] });
	});

	function updateVideo() {
		const url_video = this.dataset.src;
		if (!url_video) {
			return;
		}

		var regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
		var match = url_video.match(regExp);
		if (!match) {
			return;
		}

		this.parentNode.classList.add("video-launched");
		this.parentNode.innerHTML = `<iframe src="//www.youtube-nocookie.com/embed/${match[1]}?&autoplay=1" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
	}

	const videoPlayers = document.querySelectorAll(".js-launch-video");
	videoPlayers.forEach((el) => {
		el.addEventListener("click", function (e) {
			if (openOembedVideoModal(this)) {
				e.preventDefault();
				return;
			}
			updateVideo.call(this, e);
		});
	});

	let formInput = document.querySelectorAll("form:not(.form-estimation) .form__field input");
	if (formInput) {
		formInput.forEach((el) => {
			let parentNode = el.parentNode;
			el.addEventListener("focus", (e) => {
				parentNode.classList.add("is-focused");
			});

			el.addEventListener("blur", (e) => {
				if (parentNode.classList.contains("is-focused")) {
					parentNode.classList.remove("is-focused");
				}
			});

			el.addEventListener("keyup", (e) => {
				if (el.value) {
					parentNode.classList.add("is-filled");
				} else {
					parentNode.classList.remove("is-focused is-filled");
				}
			});
		});
	}

	/* -------------------------------------------------------------------------- */
	/*             fix label above on gravity form if form has errors             */
	/* -------------------------------------------------------------------------- */

	let form = document.querySelector("[id^='gform_wrapper'");
	if (form) {
		jQuery(document).bind("gform_post_render", function () {
			$('form .gform-body input[name^="input_"]').on("focus", function () {
				$(this).parents(".ginput_container").siblings(".gfield_label").addClass("label-above");
			});
			$('form .gform-body input[name^="input_"]').on("blur", function () {
				if ($(this).val() === "") {
					$(this).parents(".ginput_container").siblings(".gfield_label").removeClass("label-above");
				}
			});
		});
	}

	/* --------------------------------------------------------------------------- */

	// Sous-menus / méga-menu : survol + CSS sur desktop (≥1201px), clic accordéon sur tablette & mobile (≤1200px)
	document.querySelectorAll(".nav--header .navbar__item.has-children").forEach((item) => {
		const container = item.querySelector(".navbar__submenu, .megamenu");
		const parentLink = item.querySelector(":scope > a");
		if (!container || !parentLink) {
			return;
		}

		parentLink.setAttribute("aria-expanded", "false");

		parentLink.addEventListener("click", (e) => {
			if (!mediaQueryTablet.matches) {
				return;
			}

			e.preventDefault();

			const isActive = container.classList.contains("is-active");

			if (!isActive) {
				closeSiblingMobileSubnav(item);
				item.classList.add("is-open");
				container.classList.add("is-active");
				container.style.height = "auto";
				const height = container.scrollHeight + "px";
				container.style.height = "0px";
				requestAnimationFrame(() => {
					container.style.height = height;
				});
				parentLink.setAttribute("aria-expanded", "true");
			} else {
				item.classList.remove("is-open");
				container.style.height = "0px";
				parentLink.setAttribute("aria-expanded", "false");
				container.addEventListener(
					"transitionend",
					() => {
						container.classList.remove("is-active");
					},
					{ once: true },
				);
			}

			syncHeaderMegamenuFromDom();
		});
	});

	//Form => add class on label on input focus
	$('form[id*="gform_"').each(function () {
		$(".gfield").each((i, el) => {
			$(el)
				.find("input, textarea")
				.on("focus", function () {
					if (!$(el).find(".gfield_label").hasClass(".label-above")) $(el).find(".gfield_label").addClass("label-above");
				});
			$(el)
				.find("input, textarea")
				.on("focusout", function () {
					if ($(this).val() === "") $(el).find(".gfield_label").removeClass("label-above");
				});
		});
	});

	let mobileSlider = document.querySelector(".slider-on-mobile");

	// Mobile slider
	if (mobileSlider) {
		const breakpoint = window.matchMedia("(max-width:879px)");

		let mobileSwiper;
		const breakpointChecker = function () {
			if (breakpoint.matches === true) {
				// Initilise swiper
				return enableSwiper();
			} else if (breakpoint.matches === false) {
				if (mobileSwiper !== undefined) mobileSwiper.destroy(true, true);
				return;
			}
		};

		const enableSwiper = function () {
			mobileSwiper = new Swiper(".slider-on-mobile", {
				slidesPerView: 1,
				allowTouchMove: true,
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				spaceBetween: 20,
				navigation: {
					nextEl: ".swiper-mobile-button-next",
					prevEl: ".swiper-mobile-button-prev",
				},
			});
		};

		// keep an eye on viewport size changes
		breakpoint.addListener(breakpointChecker);
		breakpointChecker();
	}

	// Bandeau logos (base.twig) : autoplay, 1.8 slide visible, uniquement ≤879px
	const logoGroupSliderRoot = document.querySelector(".logo-group-slider");
	const logoGroupSlidesCount = logoGroupSliderRoot ? logoGroupSliderRoot.querySelectorAll(".swiper-mobile-slide").length : 0;

	if (logoGroupSliderRoot instanceof Element && logoGroupSlidesCount > 0) {
		const logoGroupBreakpoint = window.matchMedia("(max-width: 879px)");
		let logoGroupSwiper;
		const reduceMotionLogos = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		const enableLogoGroupSwiper = () => {
			logoGroupSwiper = new Swiper(logoGroupSliderRoot, {
				slideClass: "swiper-mobile-slide",
				wrapperClass: "swiper-mobile-wrapper",
				spaceBetween: 12,
				grabCursor: false,
				loop: true,
				slidesPerView: 1.4,
				autoplay: {
					enabled: true,
					delay: 0,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
				centerInsufficientSlides: true,
				speed: 4000,
			});
		};

		const logoGroupBreakpointChecker = () => {
			if (logoGroupBreakpoint.matches) {
				if (logoGroupSwiper === undefined) {
					enableLogoGroupSwiper();
				}
			} else if (logoGroupSwiper !== undefined) {
				logoGroupSwiper.destroy(true, true);
				logoGroupSwiper = undefined;
			}
		};

		logoGroupBreakpoint.addEventListener("change", logoGroupBreakpointChecker);
		logoGroupBreakpointChecker();
	}

	// Swiper for repeater cards simple
	Fancybox.bind('.card__swiper .swiper-slide:not(.swiper-slide-duplicate) > [data-fancybox^="card-gallery"]', {});
	const repeater_cards_swipers = document.querySelectorAll(".card__swiper");
	const repeater_cards_swipers_array = [];
	repeater_cards_swipers.forEach((elm, index) => {
		repeater_cards_swipers_array[index] = new Swiper(elm, {
			speed: 400,
			navigation: {
				nextEl: elm.querySelector(".swiper-button-next"),
				prevEl: elm.querySelector(".swiper-button-prev"),
			},
		});
	});

	if ($("body.single-post").length > 0) {
		$('iframe[src*="youtube"]').wrap("<div class='ta-vid-cont'></div>");
	}

	// Slider agencies
	const sliderAgencies = document.querySelector(".slider-agencies");
	if (sliderAgencies) {
		const swiper = sliderAgencies.querySelector(".swiper");
		const swiperNav = document.querySelector(".slider-agencies__actions");

		new Swiper(swiper, {
			slidesPerView: 1.25,
			spaceBetween: 12,
			speed: 600,
			allowTouchMove: true,
			slidesOffsetAfter: 40,
			breakpoints: {
				768: {
					slidesPerView: 2.25,
					spaceBetween: 32,
					slidesOffsetAfter: parseFloat(getComputedStyle(document.body).getPropertyValue("--_offset-x-start")) || 0,
					navigation: {
						nextEl: swiperNav.querySelector(".swiper-button-next"),
						prevEl: swiperNav.querySelector(".swiper-button-prev"),
						disabledClass: "is-disabled",
					},
				},
			},
		});
	}

	// lazy load background image
	var lazyloadImages;
	if ("IntersectionObserver" in window) {
		lazyloadImages = document.querySelectorAll(".lazy-bg");
		var imageObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					var image = entry.target;
					$(image).css("background", 'url("' + $(image).attr("data-bg-image") + '") no-repeat center/cover');
					image.classList.remove("lazy-bg");
					imageObserver.unobserve(image);
				}
			});
		});

		lazyloadImages.forEach(function (image) {
			imageObserver.observe(image);
		});
	} else {
		var lazyloadThrottleTimeout;
		lazyloadImages = document.querySelectorAll(".lazy-bg");

		function lazyload() {
			if (lazyloadThrottleTimeout) {
				clearTimeout(lazyloadThrottleTimeout);
			}

			lazyloadThrottleTimeout = setTimeout(function () {
				var scrollTop = window.pageYOffset;
				lazyloadImages.forEach(function (img) {
					if (img.offsetTop < window.innerHeight + scrollTop) {
						img.src = img.dataset.src;
						img.classList.remove("lazy");
					}
				});
				if (lazyloadImages.length == 0) {
					document.removeEventListener("scroll", lazyload);
					window.removeEventListener("resize", lazyload);
					window.removeEventListener("orientationChange", lazyload);
				}
			}, 20);
		}

		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}

	// Sync état dépendant du scroll (header, animations .js-animate, etc.)
	window.dispatchEvent(new Event("scroll"));
});
